import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonFieldsService } from 'app/laas/common-fields.service';
import { Observable } from 'rxjs';
import { ApplicantService } from 'app/laas/applicant.service';
import { AdminAuthService } from 'app/admin/admin-auth.service';
import { Router } from '@angular/router';
 

@Component({
  selector: 'wl-consent-disabled',
  template: `
  <h3 style='text-align:center;'>Are you Sure ?</h3>
  <p style='text-align:center;'>If you Choose Yes, you wont be able to proceed to further.!</p>
  <form novalidate [formGroup]="otpForm"> 
  <mat-progress-bar *ngIf="isOtpVerifying"  mode="buffer"></mat-progress-bar> 
  <div style="display:flex;flex-direction:row;justify-content:center;align-items:center;">
     <wl-button style="flex:1 1 30%;" (click)="closeDialog()" >Continue</wl-button>
    <wl-button style="flex:1 1 30%;"   (click)="confirmkccdisable()">Yes</wl-button>
  </div>
  
  </form>
  `,

})

export class ConsentDisabledComponent {
  kcc_form_disable:boolean=false;

  otpForm: UntypedFormGroup;
  otp: any;
  isOtpVerifying: boolean;
  mobile: any;
  password: any;
  company: any;
  roleId: any;

  constructor(
    private fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<ConsentDisabledComponent>,
    private adminAuth: AdminAuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private admin: AdminAuthService
  ) {
    this.otpForm = this.fb.group({
      otpCode: ['', Validators.required]
    })
    this.mobile = data.mobile;
    this.password = data.password
    this.roleId = data.roleId;
    console.log("Company " + JSON.stringify(data.mobile));
  }

  verify(val) {
    this.isOtpVerifying = true;
    console.log("otp ", val.otpCode);
    this.otp = val.otpCode;
    val.mobile = this.mobile;
    val.roleId = this.roleId;
    // this.admin.verifyOtp(this.mobile,this.otp,this.roleId).subscribe(resp => {
    this.admin.verifyOtp(this.mobile, this.otp).subscribe(resp => {

      this.isOtpVerifying = false;
      if (resp) {
        this.dialogRef.close(resp);
      } else {
        this.dialogRef.close(false);
      }
    })

  }
  closeDialog() {
    this.dialogRef.close({ data: true })

  }






  confirmkccdisable(){
    this.dialogRef.close({ data: 'yes confirmed' })
   }

}



@Component({
  selector: "wl-consent-formweb",
  templateUrl: "./consent-formweb.component.html",
  styles: [],
  providers: [CommonFieldsService, ApplicantService],
})
export class ConsentFormWebComponent implements OnInit {
  detail: any;
  isDataPending = false;
  bankAccForm: UntypedFormGroup;
  multiCropDetailsForm: UntypedFormGroup;
  crops: Observable<any>;
  acre1: number = 0;
  acre2: number = 0;
  acre3: number = 0;
  acresum: String = "0";
  consentformdata: any;
  kcc_form_disable: boolean = false;
  kharifDisabled:boolean=true;
  rabiDisabled:boolean=true;
  summerDisabled:boolean=true;
  yeskcc: boolean = false;
  cropping_pattern: any;
  kcc_form_flag: boolean = false;
  yeskccrdbtn1: any;
  applicantId: any;
  consent_update_status: any;
  consent_save_status: any;
  gunta1: any = 0;
  gunta2: any = 0;
  gunta3: any = 0;
  acressum: number = 0;
  guntassum: number = 0;
  acressumnum: any = "0";
  newCrops: any;
  proposedAmt: any = 0;
  loanAmountInNumbers: any;
  loanAmountInDecimals: any;
  constructor(
    private fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    private common: CommonFieldsService,
    private applicant: ApplicantService,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.bankAccForm = this.fb.group({
      bank_acc_no: ["", Validators.required],
      name_of_borrower: ["", Validators.required],
      name_of_co_applicant: [""],
      corps_address: ["", Validators.required],
      customer_id: ["", Validators.required],
      declaration: ["", Validators.required],
      kharif: [],
      rabi: [],
      summer: [],
      kharif_acres: [],
      rabi_acres: [],
      summer_acres: [],
      type_of_facility: ["", Validators.required],
      existing_loan_in_lakhs: ["", Validators.required],
      outstanding_as_on: ["", Validators.required],
      roi: ["", Validators.required],
      margin: ["", Validators.required],
      acresum: ["", ""],
      due_date_of_renew: ["", Validators.required],
      type_of_facilities: ["", Validators.required],
      proposed_limit: ["", Validators.required],
      rate_of_interest: ["", Validators.required],
      minimum_margin: ["", Validators.required],
      securities: ["", Validators.required],
      kcc_loanamt_cbs: ["", Validators.required],
      kcc_loanamt_farmer: [0,],
      is_renewal_kcc_limit_required: ["", Validators.required],
      is_cropping_insurance_required: ["", Validators.required],
      rabi_gunta: [""],
      summer_gunta: [""],
      kharif_guntas: [""],
      acressumnum: [""],
      kharifId: [""],
      rabiId: [""],
      summerId: [""],
    });

    this.multiCropDetailsForm = this.fb.group({
      acressumnum: [""],
      cropArrayKharif: this.fb.array([]),
      cropArrayRabi: this.fb.array([]),
      cropArraySummer: this.fb.array([]),
    });
  }

  cropArrayKharif(): UntypedFormArray {
    return this.multiCropDetailsForm.get("cropArrayKharif") as UntypedFormArray;
  }
  cropArrayRabi(): UntypedFormArray {
    return this.multiCropDetailsForm.get("cropArrayRabi") as UntypedFormArray;
  }
  cropArraySummer(): UntypedFormArray {
    return this.multiCropDetailsForm.get("cropArraySummer") as UntypedFormArray;
  }

  newCropArrayKharif(): UntypedFormGroup {
    return this.fb.group({
      kharif: "",
      kharifId: "",
      kharif_acres: "",
      kharif_guntas: "",
    });
  }

  newCropArrayRabi(): UntypedFormGroup {
    return this.fb.group({
      rabi: "",
      rabiId: "",
      rabi_acres: "",
      rabi_gunta: "",
    });
  }

  newCropArraySummer(): UntypedFormGroup {
    return this.fb.group({
      summer: "",
      summerId: "",
      summer_acres: "",
      summer_gunta: "",
    });
  }

  addKharifCrop() {
    this.cropArrayKharif().push(this.newCropArrayKharif());
  }

  addRabiCrop() {
    this.cropArrayRabi().push(this.newCropArrayRabi());
  }

  addSummerCrop() {
    this.cropArraySummer().push(this.newCropArraySummer());
  }

  removeRowKharif(i) {
    this.cropArrayKharif().removeAt(i);
    this.totalacres();
  }
  removeRowRabi(i) {
    this.cropArrayRabi().removeAt(i);
    this.totalacres();
  }
  removeRowSummer(i) {
    this.cropArraySummer().removeAt(i);
    this.totalacres();
  }

  async ngOnInit() {


    await this.applicant.getLoanAmountStrings().subscribe((resp)=>{
      sessionStorage.setItem('loanAmounts',JSON.stringify(resp))
      this.loanAmountInNumbers = JSON.parse(sessionStorage.getItem('loanAmounts')).LOAN_LIMIT;
      this.loanAmountInDecimals = JSON.parse(sessionStorage.getItem('loanAmounts')).LOAN_LIMIT_DECIMAL;
      this.multiCropDetailsForm.controls["loanAmtFarmer"].setValidators([
        Validators.required,
        Validators.max(this.loanAmountInNumbers), Validators.min(1)
      ]);
    },(err)=>{
      this.router.navigate(['/no_page'])
    })

    this.addKharifCrop();
    this.addRabiCrop();
    this.addSummerCrop();
    /*   this.bank.get().subscribe(data => {
      if (data && data.input) {
        this.bankAccForm.patchValue(data.input);
      }
      if (data && data.output) {
        this.detail = data.output;
      }
    }); */

    let urlvalue = window.location.href;
    this.applicantId = urlvalue.split("/")[urlvalue.split("/").length - 1];
    sessionStorage.setItem("applicantId", this.applicantId);
    let payload = { applicantId: this.applicantId };
    console.log(payload, "fdgfdgdfgdfgd");
    this.applicant.getcropsdata().subscribe((res) => {
      console.log(res, "ressssssssssssssssssssss");
      this.crops = res;
      let reformattedArray = res.map((obj) => {
        let rObj = {};
        rObj["name"] = obj.crop_name;
        rObj["id"] = obj.id;
        rObj["rainfed"] = obj.rainfed;
        rObj["irrigated"] = obj.irrigated;

        return rObj;
      });
      //{id: 18, crop_name: 'Mango', rainfed: '37250', irrigated: '37250'}
      this.newCrops = reformattedArray;
    });
    console.log(this.crops, "cropsss");
    this.consentformdata = this.applicant
      .getconsentformdata(payload)
      .subscribe((resp) => {
        console.log(
          "response from getconsentformdata 5446" + JSON.stringify(resp)
        );
        console.log(
          "response from getconsentformdata",
          resp.result.user_docs.coapplicant_data
        );
        let resd = resp.result.user_docs;
        this.consent_update_status = resp.result.consent_update_status;
        this.bankAccForm.patchValue({
          name_of_borrower: resd.applicant_name,
          // name_of_co_applicant:resd.coapplicant_data.co_applicant_name,
          bank_acc_no: resd.kcc_acc_no,
          corps_address:
            resd.resAdd.address +
            ", " +
            resd.resAdd.state +
            ", " +
            resd.resAdd.postal_code,
          customer_id: resd.custId,
          due_date_of_renew: resd.renewal_duedate_for_credit_limit,
          type_of_facility: resd.existing_loan_details.type_of_facility,
          existing_loan_in_lakhs: 0,
          outstanding_as_on: resd.existing_loan_details.outstanding_as_on,
          roi: resd.existing_loan_details.roi,
          margin: resd.existing_loan_details.margin,
          type_of_facilities: resd.existing_loan_details.type_of_facility,
          proposed_limit: resd.existing_loan_details.proposed_limit,
          rate_of_interest: resd.existing_loan_details.roi,
          minimum_margin: resd.existing_loan_details.margin,
          securities:
            "Hypothecation of Standing Crops and other Securities as per existing terms of sanction.",
          kcc_loanamt_cbs: resd.existing_dp,
        });
        this.bankAccForm.patchValue({
          name_of_co_applicant: resp.result.user_docs.coapplicant_data
            .coApp_name
            ? resp.result.user_docs.coapplicant_data.coApp_name
            : "",
        });
      });
  }

  totalacres() {
    let acresN1 = 0;
    let guntasN1 = 0;
    let acresN2 = 0;
    let guntasN2 = 0;
    let acresN3 = 0;
    let guntasN3 = 0;
    const myForm = this.multiCropDetailsForm.getRawValue();
    console.warn(myForm, "myform");
    const kharifdata = myForm.cropArrayKharif;
    const rabidata = myForm.cropArrayRabi;
    const summerdata = myForm.cropArraySummer;
    kharifdata.map((value) => {
      acresN1 = acresN1 + (value.kharif_acres ? value.kharif_acres * 1 : 0);
      guntasN1 = guntasN1 + (value.kharif_guntas ? value.kharif_guntas * 1 : 0);
    });
    rabidata.map((value) => {
      acresN2 = acresN2 + (value.rabi_acres ? value.rabi_acres * 1 : 0);
      guntasN2 = guntasN2 + (value.rabi_gunta ? value.rabi_gunta * 1 : 0);
    });
    summerdata.map((value) => {
      acresN3 = acresN3 + (value.summer_acres ? value.summer_acres * 1 : 0);
      guntasN3 = guntasN3 + (value.summer_gunta ? value.summer_gunta * 1 : 0);
    });
    this.acressum = acresN1 + acresN2 + acresN3;
    this.guntassum = guntasN1 + guntasN2 + guntasN3;
    this.returnacres(this.guntassum, this.acressum);
  }

  returnacres(guntas, sumofacres) {
    console.log(guntas, "guntas");
    console.log(sumofacres, "sumofacres");
    let acres = Math.floor(guntas / 40);
    let remainGuntas = guntas % 40;
    let totalAcres = acres + sumofacres + " acres ";
    let totalAcres1 = acres + sumofacres;
    if (remainGuntas < 10) {
      totalAcres = totalAcres + "0" + remainGuntas + " Guntas";
    } else {
      totalAcres = totalAcres + remainGuntas + " Guntas";
    }
    console.log(totalAcres, "totalacres");
    this.acresum = totalAcres;
    this.acressumnum = totalAcres1 + remainGuntas * 0.01;
  }

  returnacres1(guntas, sumofacres) {
    console.log(guntas, "guntas");
    console.log(sumofacres, "sumofacres");
    let acres = Math.floor(guntas / 40);
    let remainGuntas = guntas % 40;
    let totalAcres = acres + sumofacres + " acres ";
    let totalAcres1 = acres + sumofacres;
    if (remainGuntas < 10) {
      totalAcres = totalAcres + "0" + remainGuntas + " Guntas";
    } else {
      totalAcres = totalAcres + remainGuntas + " Guntas";
    }
    return totalAcres1 + remainGuntas * 0.01;
  }

  consentformSubmit() { 
    const formdata = this.multiCropDetailsForm.getRawValue();
    let formdata1 = this.bankAccForm.getRawValue();
    console.warn(formdata,"formmmmmmmm");
    console.warn(this.multiCropDetailsForm,"formmmmmmmm");
    const kharifdata=formdata.cropArrayKharif;
    const rabidata=formdata.cropArrayRabi;
    const summerdata=formdata.cropArraySummer;

    let khariffinaldata=[];
    let rabifinaldata=[];
    let summerfinaldata=[];
    kharifdata.map(value => {
      khariffinaldata.push({
        name_of_the_crop: this.objectFindByKey(this.crops, "id", value.kharifId),
        acrestotal:this.returnacres1(value.kharif_guntas?value.kharif_guntas*1:0,value.kharif_acres?value.kharif_acres*1:0),   
        acres: value.kharif_acres?value.kharif_acres*1:0,
        guntas:value.kharif_guntas?value.kharif_guntas*1:0,
        total_area:formdata.acressumnum?formdata.acressumnum*1:0
      })
    })
   rabidata.map(value => {
    rabifinaldata.push({
      name_of_the_crop: this.objectFindByKey(this.crops, "id", value.rabiId),
        acrestotal:this.returnacres1(value.rabi_gunta?value.rabi_gunta*1:0,value.rabi_acres?value.rabi_acres*1:0),   
        acres: value.rabi_acres?value.rabi_acres*1:0,
        guntas:value.rabi_gunta?value.rabi_gunta*1:0,
        total_area:formdata.acressumnum?formdata.acressumnum*1:0
    })
    })
  summerdata.map(value => {
    summerfinaldata.push({
      name_of_the_crop: this.objectFindByKey(this.crops, "id", value.summerId),
      acrestotal:this.returnacres1(value.summer_gunta?value.summer_gunta*1:0,value.summer_acres?value.summer_acres*1:0),   
      acres: value.summer_acres?value.summer_acres*1:0,
      guntas:value.summer_gunta?value.summer_gunta*1:0,
      total_area:formdata.acressumnum?formdata.acressumnum*1:0
    })
    })

   /*  formdata.kharif = this.objectFindByKey(this.crops, "id", formdata.kharifId);
    console.log(formdata.kharif,"Kharif form data");
    formdata.rabi = this.objectFindByKey(this.crops, "id", formdata.rabiId);
    formdata.summer = this.objectFindByKey(this.crops, "id", formdata.summerId); */

    this.cropping_pattern = [
      {
        crop_season: "kharif",
        crop_data:khariffinaldata
      },
      {
        crop_season: "Rabi",
        crop_data:rabifinaldata
      },
      {
        crop_season: "Summer",
        crop_data:summerfinaldata
      },
    ];
    let dataobj = {
      cropping_pattern: this.cropping_pattern,
      proposed_amount: formdata1.kcc_loanamt_farmer,
      is_renewal_kcc_limit_required: formdata1.is_renewal_kcc_limit_required,
      is_cropping_insurance_required: formdata1.is_cropping_insurance_required,
    };

    this.applicant.consentformSubmit(dataobj).subscribe((resp) => {
      console.log("resp " + JSON.stringify(resp));
      if (resp) {
        this.snackbar.open(resp.message, "OK", { duration: 3000 });
      }
    });

    console.log(dataobj);
  }

  consent_form_hide() {
    var dialogRef: MatDialogRef<ConsentDisabledComponent>;
    dialogRef = this.dialog.open(ConsentDisabledComponent, {
      disableClose: true,
      height: "auto",
      width: "auto",
      data: {},
    });

    dialogRef.afterClosed().subscribe((res) => {
      console.log("res " + JSON.stringify(res));
      if (res && res.data == "yes confirmed") {
        this.kcc_form_disable = true;
        let dataobj = {
          is_renewal_kcc_limit_required: "no",
        };
        this.applicant.consentformSubmit(dataobj).subscribe((resp) => {
          console.log("resp " + JSON.stringify(resp));
        });
        // document.getElementById('kcc_form').click();
        //  this.yeskccrdbtn1="yes";
      } else if (res && res.data == true) {
        this.yeskccrdbtn1 = "yes";
        this.showkccform();
      }

      /*  if (res && res.success) {
        this.snackbar.open(res.message, 'OK', { duration: 3000 })
        this.router.navigate(['loanrenewal_web/60615f2e0df32b42a8f7e9e9']);
      } else {
        // this.snackbar.open(res.message, 'OK', { duration: 3000 })
      } */
    });
    // this.kcc_form_disable=true;
  }

  showkccform() {
    this.kcc_form_flag = true;
  }

  kharifSelectedEvent(event,i){
    console.log(i);
    const myForm = (<UntypedFormArray>this.multiCropDetailsForm.get('cropArrayKharif')).at(i);
    myForm.patchValue({kharifId:event.id}) 
    this.kharifDisabled = false; 
  }

  rabiSelectedEvent(event,i){
    const myForm = (<UntypedFormArray>this.multiCropDetailsForm.get('cropArrayRabi')).at(i);
    myForm.patchValue({rabiId:event.id}) 
    this.rabiDisabled=false; 
  }
  summerSelectedEvent(event,i){
    const myForm = (<UntypedFormArray>this.multiCropDetailsForm.get('cropArraySummer')).at(i);
    myForm.patchValue({summerId:event.id}) 
    this.summerDisabled=false;
  }

  objectFindByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }
}
